import React from "react";

import LayoutLogin from "../components/layouts/LayoutLogin";
import { Input } from "@nextui-org/input";
import { Button } from "@nextui-org/button";
import { Icon } from "@iconify/react";
import { useEffect, useMemo, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import ReverLogo from "../assets/img/rever.png";
import Atto3 from "../assets/img/atto3.png";

export default function RegisterPage() {
  const location = useLocation();
  const queryParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  const [isVisible, setIsVisible] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm_password, setConfirmPassword] = useState("");

  const toggleVisibility = () => setIsVisible(!isVisible);

  const register = () => {
    if (!email || !password || !confirm_password) {
      Swal.fire({
        html: `<h4>กรุณากรอกข้อมูลให้ครบ</h4>`,
        icon: "warning",
        confirmButtonText: "Ok",
      });
      return;
    }

    if (password !== confirm_password) {
      Swal.fire({
        html: `<h4>รหัสผ่านไม่ตรงกัน</h4>`,
        icon: "warning",
        confirmButtonText: "Ok",
      });
      return;
    }

    let data = JSON.stringify({
      email: email.toLowerCase(),
      password: password,
    });

    axios({
      method: "post",
      url: "/marketing-claim-api/v1/auth/register",
      data: data,
    }).then(function (response) {
      if (response) {
        window.location.href = "/?email=" + email;
      }
    });
  };

  useEffect(() => {
    const _code = queryParams.get("email");
    if (_code) {
      setEmail(_code);
    }
  }, [queryParams]);

  return (
    <>
      <LayoutLogin>
        <div className="min-h-screen w-full bg-black">
          <div
            className="min-h-screen w-full bg-black relative bg-cover bg-center"
            style={{ backgroundImage: `url(${Atto3})` }}
          >
            <div className="flex h-full w-full items-center justify-center text-white">
              <div className="flex w-full max-w-sm flex-col gap-4 rounded-large px-8 pb-4 pt-6 mt-20 bg-black items-center">
                <img src={ReverLogo} alt="ReverLogo" />
                <p className="py-4 text-left text-xl font-semibold">Register</p>
                <form
                  className="flex flex-col gap-4 w-full"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <Input
                    isRequired
                    id="login-input"
                    name="email"
                    placeholder="Enter your email"
                    variant="bordered"
                    onChange={(e) => setEmail(e.target.value.trim())}
                    value={email}
                    classNames={{
                      inputWrapper:
                        "focus-within:border-white group-data-[focus=true]:border-white",
                      input: "text-white placeholder:text-gray-400",
                    }}
                  />
                  <Input
                    id="login-input"
                    isRequired
                    endContent={
                      <button type="button" onClick={toggleVisibility}>
                        {isVisible ? (
                          <Icon
                            className="pointer-events-none text-2xl text-default-400"
                            icon="solar:eye-closed-linear"
                          />
                        ) : (
                          <Icon
                            className="pointer-events-none text-2xl text-default-400"
                            icon="solar:eye-bold"
                          />
                        )}
                      </button>
                    }
                    // label="Password"
                    labelPlacement="outside"
                    name="password"
                    placeholder="Enter your password"
                    type={isVisible ? "text" : "password"}
                    variant="bordered"
                    onChange={(e) => setPassword(e.target.value.trim())}
                    classNames={{
                      inputWrapper:
                        "focus-within:border-white group-data-[focus=true]:border-white",
                      input: "text-white placeholder:text-gray-400",
                    }}
                  />
                  <Input
                    id="login-input"
                    isRequired
                    endContent={
                      <button type="button" onClick={toggleVisibility}>
                        {isVisible ? (
                          <Icon
                            className="pointer-events-none text-2xl text-default-400"
                            icon="solar:eye-closed-linear"
                          />
                        ) : (
                          <Icon
                            className="pointer-events-none text-2xl text-default-400"
                            icon="solar:eye-bold"
                          />
                        )}
                      </button>
                    }
                    // label="Password"
                    labelPlacement="outside"
                    name="password"
                    placeholder="Enter your confirm password"
                    type={isVisible ? "text" : "password"}
                    variant="bordered"
                    onChange={(e) => setConfirmPassword(e.target.value.trim())}
                    classNames={{
                      inputWrapper:
                        "focus-within:border-white group-data-[focus=true]:border-white",
                      input: "text-white placeholder:text-gray-400",
                    }}
                  />

                  <Button color="primary" type="submit" onPress={register}>
                    Register
                  </Button>
                  <div className="py-2 flex justify-center gap-x-3 text-sm opacity-80">
                    <NavLink to={"/"} className="underline">
                      SIGN IN
                    </NavLink>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </LayoutLogin>
    </>
  );
}
